"use client";

import React from "react";
import Button from "../common/Button/page";

const RenderDescriptionWithCandlyLink = ({ description, demoLink }) => {
    // If no demoLink is provided, return the description as plain text
    if (!demoLink) {
        return <>{description}</>;
    }

    // Handle both string demoLink and object demoLink formats
    const target = typeof demoLink === "object" ? demoLink.text : demoLink;
    const url = typeof demoLink === "object" ? demoLink.url || "#" : "#";

    // Use case-sensitive search for more accuracy
    const index = description.indexOf(target);

    // If the specified text isn't found in the description, return the original
    if (index === -1) {
        return <>{description}</>;
    }

    const before = description.slice(0, index);
    const after = description.slice(index + target.length);

    return (
      <>
        {before}
        <p className="flex lg:justify-start justify-center">
          <Button href={url} className="text-white border-b inline px-0 py-0 mx-0 font-normal">
            {target}
          </Button>
        </p>
        {after}
      </>
    );
};

export default RenderDescriptionWithCandlyLink;
